
export const actionTypesForSignin = {
    INIT: 'INIT',
    TOGGLE_OVERLAY: 'TOGGLE_OVERLAY',
    TOGGLE_LOADING: 'TOGGLE_LOADING',
    SET_USERCREDENTIALS: 'SET_USERCREDENTIALS',
    RETURN_TO_EMAIL_VIEW: 'RETURN_TO_EMAIL_VIEW',
};

export const signinStatuses = {
    NONE: 'NONE',
    PASSWORD_REQUIRED: 'PASSWORD_REQUIRED',
    INSTANT_SIGNIN_SENT: 'INSTANT_SIGNIN_SENT',
    TEACHER_CONFIRMATION_SENT: 'TEACHER_CONFIRMATION_SENT',
    FORGOT_PASSWORD_SENT: 'FORGOT_PASSWORD_SENT',
    USERNAME_UNKNOWN: 'USERNAME_UNKNOWN',
    PASSWORD_UNKNOWN: 'PASSWORD_UNKNOWN',
    COMPLETE: 'COMPLETE',
    PRIMARY_EMAIL_AND_PASSWORD_REQUIRED: 'PRIMARY_EMAIL_AND_PASSWORD_REQUIRED',
    INSTANT_SIGNIN_SENT_TO_TEACHER_SCHOOL_EMAIL: 'INSTANT_SIGNIN_SENT_TO_TEACHER_SCHOOL_EMAIL',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
};
